import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import {
  colors,
  EXTRA_LARGE_DESKTOP_BREAKPOINT,
  LARGE_DESKTOP_BREAKPOINT,
  SPACE_COMFORTABLE,
  VIEWING_WIDTH,
} from '@/styles';

import { LARGE_CARD_WIDTH } from '../../slo-card/styles';

const TWO_COLUMN_GRID_BREAKPOINT = `${LARGE_DESKTOP_BREAKPOINT}px`;
const THREE_COLUMN_GRID_BREAKPOINT = `${EXTRA_LARGE_DESKTOP_BREAKPOINT}px`;

export const fullViewWidthChild = css`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
`;

export const largeSlosGridContainerStyles = css`
  @media screen and (min-width: ${TWO_COLUMN_GRID_BREAKPOINT}) {
    ${fullViewWidthChild}
  }
`;

export const largeSlosLoadingStyles = css`
  width: ${VIEWING_WIDTH}px;
  color: ${token('color.text.subtlest', colors.N300)};
`;

const LARGE_SLO_GRID_GAP = `${SPACE_COMFORTABLE}px`;

export const largeSlosGridStyles = (dataLength: number) => [
  css`
    display: grid;
    justify-content: center;
    margin-top: ${LARGE_SLO_GRID_GAP};
  `,
  dataLength > 1 &&
    css`
      gap: ${LARGE_SLO_GRID_GAP};

      @media screen and (min-width: ${TWO_COLUMN_GRID_BREAKPOINT}) {
        grid-template-columns: repeat(2, ${LARGE_CARD_WIDTH}px);
      }
      @media screen and (min-width: ${THREE_COLUMN_GRID_BREAKPOINT}) {
        grid-template-columns: repeat(3, ${LARGE_CARD_WIDTH}px);
      }
    `,
];
